'use strict';

angular.module('app').directive('triggerDatepicker', function($window, $timeout) {
  return function(scope, elem, attr) {
    $(elem).on('click', function(e) {
      var datepicker = $('header .js-from'),
        selectDatesBtn = $('#select-dates');

      $timeout(function() {
        if (!datepicker.is(':visible')) {
          selectDatesBtn.click();
        }
        datepicker.click();
      }, 150);
    });
  };
});


angular.module('app').directive('triggerDatepickerManual', function($window, $timeout) {
  return function(scope, elem, attr) {
    $(elem).on('click', function(e) {
      var datepicker = $(attr.triggerDatepickerManual);

      $timeout(function() {
        datepicker.click();
      }, 150);
    });
  };
});

angular.module('app').directive('triggerDatepickerSearchPage', function($window, $timeout) {
  return function(scope, elem, attr) {
    $(elem).on('click', function(e) {
      e.stopPropagation();
      var dp = $('.search-wrapper [travel-datepicker]'),
          filterTrigger = $('.filter-expand');

      if (window.innerWidth < 767 && filterTrigger.hasClass('active') === false) {
        filterTrigger.click();
      }

      $timeout(function() {
        dp.click();
      }, 150);
    });
  };
});